'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107 from "./presto.-Presto-Router$$anon$107.js";
import * as $j_presto$002e$002dSigning$002dPage$0024 from "./presto.-Signing-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$106() {
  this.bdK = null;
  this.bdC = null;
  this.bdD = false;
  this.bdL = null;
  this.bdM = false;
  this.bdP = null;
  this.bdI = null;
  this.bdJ = false;
  this.bdE = null;
  this.bdF = false;
  this.bdG = null;
  this.bdH = false;
  this.bdN = false;
  this.bdO = false;
  this.bdK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdP = "SigningPage";
}
export { $c_Lpresto_PrestoRouter$$anon$106 as $c_Lpresto_PrestoRouter$$anon$106 };
$p = $c_Lpresto_PrestoRouter$$anon$106.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$106;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$106() {
}
export { $h_Lpresto_PrestoRouter$$anon$106 as $h_Lpresto_PrestoRouter$$anon$106 };
$h_Lpresto_PrestoRouter$$anon$106.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bdK;
});
$p.L = (function() {
  if ((!this.bdD)) {
    this.bdC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bdD = true;
  }
  return this.bdC;
});
$p.O = (function() {
  if ((!this.bdM)) {
    this.bdL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdM = true;
  }
  return this.bdL;
});
$p.E = (function() {
  return this.bdP;
});
$p.t = (function() {
  if ((!this.bdJ)) {
    this.bdI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdJ = true;
  }
  return this.bdI;
});
$p.M = (function() {
  if ((!this.bdF)) {
    this.bdE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdF = true;
  }
  return this.bdE;
});
$p.Q = (function() {
  if ((!this.bdH)) {
    this.bdG = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107.$c_Lpresto_PrestoRouter$$anon$107();
    this.bdH = true;
  }
  return this.bdG;
});
$p.w = (function() {
  if ((!this.bdO)) {
    this.bdN = false;
    this.bdO = true;
  }
  return this.bdN;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee638) => ((p) => \u03b4scrutinee638.cG9(p)))($j_presto$002e$002dSigning$002dPage$0024.$m_Lpresto_SigningPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$106 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$106, "presto.PrestoRouter$$anon$106", ({
  Nt: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$106 as $d_Lpresto_PrestoRouter$$anon$106 };
//# sourceMappingURL=presto.-Presto-Router$$anon$106.js.map
